import { headingStyles } from "../../assets/styles/CommonStyles";
import { majorRoutes } from "../../constants/majorRoutes";
import { useFormUnsavedChanges } from "../../hooks/useFormUnsavedChanges";
import { React, useState, useEffect, Typography, Outlet, TopBar, AppLayout, Box, CustomButton, IconButton } from "../../utils/globalImports";
import { useNavigate, useLocation, useParams, ArrowBackIosIcon, Dayjs, dayjs, useApi, Toaster, validationMessages, FormType } from '../../utils/globalImports';
import { validateField, validationPatterns } from "../../utils/validationUtils";
// import { usePageLock } from '../../hooks/usePageLock';

interface Project {
    projectId?: number;
    projectNumber?: string | null;
    projectName: string;
    clientId?: number;
    clientName?: string;
    startDate?: string | null;
    endDate?: Dayjs | null;
    description?: string | null;
    projectTags?: ProjectTags[];
    assistantProjectManagerId?: string | number | null;
    projectManagerId?: string | number | null;
    bidCoordinatorId?: string | number | null;
    technicalProjectLeadId?: number | null;
    assistantTechnicalProjectLeadId?: string | number | null;
    status: number;
    createdId?: number;
    updatedId?: number;
    createdAt?: Date;
    updatedAt?: Date;
    frameworks?: { clientId: number | null }[];
    isExistProposal: boolean;
    proposalMaxEndDate: Dayjs | null;
}

interface ProjectTags {
    projectId?: number;
    tagId: number;
}

const commonTabs = [
    { name: "General", path: "general" },
];

const addProjectTabs = [...commonTabs];

const editProjectTabs = [
    ...commonTabs,
    { name: "AFP", path: "afp" },
    { name: "Summary", path: "summary" },
    { name: "Notes/Comments", path: "notes" },
    { name: "Attachments", path: "attachments" },
    { name: "Forecast Tracker", path: "forecast-tracker" },
    { name: "AFP Tracker", path: "afp-tracker" },
    { name: "Invoice Tracker", path: "invoice-tracker" },
    { name: "Category/Subcategory", path: "category/categories" }
];

const AddProject: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { projectId } = useParams();

    const searchParams = new URLSearchParams(location.search);
    const clientIdFromQuery = searchParams.get('clientId');
    const fromPage = location.state?.from;
    const { execute } = useApi();
    const isEditMode = Boolean(projectId);
    const [afpSubmissionDate, setAfpSubmissionDate] = useState<Dayjs | null>(null);
    const [afpCertificateDate, setAfpCertificateDate] = useState<Dayjs | null>(null);
    const [paymentDate, setPaymentDate] = useState<Dayjs | null>(null);
    const [afpMonthlyInterval, setAfpMonthlyInterval] = useState<number>(0);
    const [afpCertificateInterval, setAfpCertificateInterval] = useState<number>(0);
    const [expectedPaymentInterval, setExpectedPaymentInterval] = useState<number>(0);
    const tabs = isEditMode
        ? editProjectTabs.map(tab => ({ ...tab, path: `/project/edit-projects/${projectId}/${tab.path}` }))
        : addProjectTabs.map(tab => ({ ...tab, path: `/project/add-projects/${tab.path}` }));
    const userId = Number(localStorage.getItem("userId"));


    // const userName = localStorage.getItem("name");

    const [toast, setToast] = useState({ open: false, message: "", type: "success" as "success" | "error" | "warning" });
    const [formData, setFormData] = useState({
        projectNumber: '',
        startDate: null as Dayjs | null,
        associatedClient: "-1",
        projectTags: [] as number[],
        status: 'Active',
        projectName: '',
        endDate: null as Dayjs | null,
        projectDescription: '',
        associatedFrameworkGroup: -1,
        bidCoordinator: "-1",
        projectManager: "-1",
        technicalProjectLead: "-1",
        assistantProjectManager: "-1",
        assistantTechnicalProjectLead: "-1",
        isExistProposal: false,
        proposalMaxEndDate: null as Dayjs | null
    });

    const [initialFormData, setInitialFormData] = useState({
        projectNumber: '',
        startDate: null as Dayjs | null,
        associatedClient: "-1",
        projectTags: [] as number[],
        status: 'Active',
        projectName: '',
        endDate: null as Dayjs | null,
        projectDescription: '',
        associatedFrameworkGroup: -1,
        bidCoordinator: "-1",
        projectManager: "-1",
        technicalProjectLead: "-1",
        assistantProjectManager: "-1",
        assistantTechnicalProjectLead: "-1",
        isExistProposal: false,
        proposalMaxEndDate: null as Dayjs | null
    });
    const [afpData, setAfpData] = useState({
        afpType: null,
        afpToCertificate: null,
        invoiceToPayment: null
    });

    // const { requestLock, requestUnlock } = usePageLock(
    //     FormType.Project,
    //     Number(projectId),
    //     userName!
    // );

    useEffect(() => {
        if (isEditMode && projectId) {
            fetchProjectDetails(Number(projectId));
        }

    }, [isEditMode, projectId]);

    const [errors, setErrors] = useState({
        projectNumber: '',
        projectName: '',
        startDate: '',
        endDate: '',
        associatedClient: '',
        projectDescription: '',
        afpToCertificate: '',
        invoiceToPayment: '',
        afpSubmissionDate: '',
        afpCertificateDate: '',
        paymentDate: '',
        afpSubmissionInterval: '',
        afpCertificateInterval: '',
        expectedPaymentInterval: ''
    });

    const validate = () => {
        let isValid = true;
        //const newErrors = { projectNumber: '', projectName: '', startDate: '', endDate: '', associatedClient: '', projectDescription: '', afpToCertificate: '', invoiceToPayment: '', afpSubmissionDate: '', afpCertificateDate: '', paymentDate: '', afpSubmissionInterval: '', afpCertificateInterval: '', expectedPaymentInterval: '' };
        //const specialCharRegex = /[^a-zA-Z0-9\s\-]/;

        // if (!formData.projectNumber.trim()) {
        //     newErrors.projectNumber = validationMessages.common_required("Project Number");
        //     isValid = false;
        // } else if (specialCharRegex.test(formData.projectNumber)) {
        //     newErrors.projectNumber = validationMessages.common_invalidSpecialChar("Project Number");
        //     isValid = false;
        // } else if (formData.projectNumber.length > 20) {
        //     newErrors.projectNumber = validationMessages.common_characterLimit("Project Number", 20);
        //     isValid = false;
        // }
        const newErrors = {
            projectNumber: "",
            projectName: "",
            startDate: "",
            endDate: "",
            associatedClient: "",
            projectDescription: "",
            afpToCertificate: "",
            invoiceToPayment: "",
            afpSubmissionDate: "",
            afpCertificateDate: "",
            paymentDate: "",
            afpSubmissionInterval: "",
            afpCertificateInterval: "",
            expectedPaymentInterval: ""
        };
        newErrors.projectName = validateField(formData.projectName, {
            fieldName: "Project Name",
            required: true,
            maxLength: 100,
        });

        if (newErrors.projectName) isValid = false;

        newErrors.startDate = validateField(formData.startDate, {
            fieldName: "Start Date",
            required: true
        });
        if (newErrors.startDate) isValid = false;

        // End Date Required Check
        newErrors.endDate = validateField(formData.endDate, {
            fieldName: "End Date",
            required: true
        });
        if (newErrors.endDate) isValid = false;


        if (formData.startDate && formData.endDate) {
            const startDate = formData.startDate.toDate(); // Convert Dayjs to JavaScript Date
            const endDate = formData.endDate.toDate(); // Convert Dayjs to JavaScript Date

            if (startDate >= endDate) {
                newErrors.startDate = "Start Date must be earlier than End Date.";
                newErrors.endDate = "End Date must be later than Start Date.";
                isValid = false;
            }
        }
        if (formData.endDate) {
            const minAllowed = formData.proposalMaxEndDate || formData.startDate;

            if (minAllowed && formData.endDate.isBefore(minAllowed, "day")) {
                newErrors.endDate = `End date cannot be earlier than proposal End date ${minAllowed.format("DD-MM-YYYY")}`;
                isValid = false;
            }
        }

        newErrors.associatedClient = validateField(formData.associatedClient, {
            fieldName: "Associated Client",
            required: true
        });
        if (newErrors.associatedClient) isValid = false;

        newErrors.projectDescription = validateField(formData.projectDescription, {
            fieldName: "Project Description",
            maxLength: 5000
        });

        if (newErrors.projectDescription) isValid = false;

        if (afpData.afpType === 'asRequired') {
            // Validate afpToCertificate
            if (
                afpData.afpToCertificate === null ||
                afpData.afpToCertificate === undefined ||
                isNaN(Number(afpData.afpToCertificate)) ||
                Number(afpData.afpToCertificate) <= 0
            ) {
                newErrors.afpToCertificate = validationMessages.common_required("AFP to Certificate");
                isValid = false;
            }

            // Validate invoiceToPayment
            if (
                afpData.invoiceToPayment === null ||
                afpData.invoiceToPayment === undefined ||
                isNaN(Number(afpData.invoiceToPayment)) ||
                Number(afpData.invoiceToPayment) <= 0
            ) {
                newErrors.invoiceToPayment = validationMessages.common_required("Invoice to Payment");
                isValid = false;
            }
        }

        if (afpData.afpType === 'scheduled') {
            // Validate afp scheduled dates
            if (!afpSubmissionDate) {
                newErrors.afpSubmissionDate = validationMessages.common_required("AFP Submission Date");
                isValid = false;
            }
            // Validate afp certificate dates
            if (!afpCertificateDate) {
                newErrors.afpCertificateDate = validationMessages.common_required("AFP Certificate Date");
                isValid = false;
            }
            // Validate payment dates
            if (!paymentDate) {
                newErrors.paymentDate = validationMessages.common_required("Expected Payment Date");
                isValid = false;
            }
            // Validate afp submission interval
            if (afpMonthlyInterval <= 0) {
                newErrors.afpSubmissionInterval = validationMessages.common_required("AFP Submission Interval");
                isValid = false;
            }
            // Validate afp certificate interval
            if (afpCertificateInterval <= 0) {
                newErrors.afpCertificateInterval = validationMessages.common_required("AFP Certificate Interval");
                isValid = false;
            }
            // Validate expected payment interval 
            if (expectedPaymentInterval <= 0) {
                newErrors.expectedPaymentInterval = validationMessages.common_required("Expected Payment Interval");
                isValid = false;
            }
        }

        setErrors(newErrors);
        return isValid;
    };

    const fetchProjectDetails = async (id: number) => {
        const { data } = await execute<Project>('get', `/Project/GetProject/${id}`);


        if (data) {
            const formData = {
                projectNumber: data.projectNumber || '',
                startDate: data.startDate ? dayjs(data.startDate, "YYYY-MM-DDTHH:mm:ss") : null,
                associatedClient: data.clientId ? data.clientId.toString() : "-1",
                projectTags: data.projectTags ? data.projectTags.map(tag => tag.tagId) : [],
                status: data.status === 1 ? 'Active' : 'Inactive',
                projectName: data.projectName || '',
                endDate: data.endDate ? dayjs(data.endDate, "YYYY-MM-DDTHH:mm:ss") : null,
                projectDescription: data.description || '',
                associatedFrameworkGroup: 1,
                bidCoordinator: data.bidCoordinatorId ? data.bidCoordinatorId.toString() : "-1",
                projectManager: data.projectManagerId ? data.projectManagerId.toString() : "-1",
                technicalProjectLead: data.technicalProjectLeadId ? data.technicalProjectLeadId.toString() : "-1",
                assistantProjectManager: data.assistantProjectManagerId ? data.assistantProjectManagerId.toString() : "-1",
                isExistProposal: data.isExistProposal || false,
                proposalMaxEndDate: data.proposalMaxEndDate ? dayjs(data.proposalMaxEndDate, "YYYY-MM-DDTHH:mm:ss") : null,
                assistantTechnicalProjectLead: data.assistantTechnicalProjectLeadId ? data.assistantTechnicalProjectLeadId.toString() : "-1"
            };
            setFormData(formData);
            setInitialFormData(formData);
        }
    };


    const handleSaveProject = async () => {
        if (!validate()) {
            return;
        }
        try {

            const projectTags: ProjectTags[] = formData.projectTags.map((tagId: number) => ({
                tagId
            }));

            const normalizeValue = (value: any) => (value === 0 || value === -1 ? null : value);
            const payload = {
                projectId: isEditMode ? Number(projectId) : undefined,
                projectNumber: formData.projectNumber,
                projectName: formData.projectName,
                startDate: formData.startDate
                    ? dayjs(formData.startDate).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
                    : null,
                endDate: formData.endDate
                    ? dayjs(formData.endDate).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
                    : null,
                clientId: Number(formData.associatedClient),
                description: formData.projectDescription || null,
                projectTags: projectTags,
                // proposalTagId: normalizeValue(Number(formData.projectTags)),
                status: formData.status === 'Active' ? 1 : 0,
                assistantProjectManagerId: normalizeValue(Number(formData.assistantProjectManager)),
                projectManagerId: normalizeValue(Number(formData.projectManager)),
                bidCoordinatorId: normalizeValue(Number(formData.bidCoordinator)),
                technicalProjectLeadId: normalizeValue(Number(formData.technicalProjectLead)),
                assistantTechnicalProjectLeadId: normalizeValue(Number(formData.assistantTechnicalProjectLead)),
                createdId: userId,
                updatedId: 0,
                createdAt: new Date().toISOString(),
                updatedAt: new Date().toISOString(),
                parties: [],
                frameworks: formData.associatedFrameworkGroup === 0 ?
                    [{
                        clientId: Number(formData.associatedClient)
                    }]
                    : [],
                notes: [],
                attachments: []
            };

            const method = isEditMode ? 'put' : 'post';
            const endpoint = isEditMode ? `/Project/UpdateProject` : '/Project/AddProject';

            // Create or update project
            const response = await execute<{ projectId: number }>(method, endpoint, payload);

            if (response.error) {

                let parsedError: any = response.error;

                if (typeof response.error === "string") {
                    try {
                        parsedError = JSON.parse(response.error);
                    } catch {
                        setToast({ open: true, message: response.error, type: "error" });
                        return;
                    }
                }

                if (typeof parsedError === "object" && parsedError !== null) {
                    const defaultErrors = {
                        projectNumber: "",
                        projectName: "",
                        startDate: "",
                        endDate: "",
                        associatedClient: "",
                        projectDescription: ""
                    };

                    const mergedErrors = { ...defaultErrors, ...parsedError };
                    setErrors(mergedErrors);
                    return;
                }

                // Fallback just in case
                setToast({ open: true, message: "Unknown error occurred.", type: "error" });
                return;
            }

            const newProjectId = response.data?.projectId;

            setInitialFormData(formData);
            if (!isEditMode) {
                setToast({ open: true, message: "Project created successfully!", type: 'success' });
                navigate(`/project/edit-projects/${newProjectId}/general`);

            } else {
                setToast({ open: true, message: "Project updated successfully!", type: 'success' });
                // setTimeout(() => {
                //     navigate('/project/projects');
                // }, 1000);
            }
        } catch (error) {
            setToast({ open: true, message: "Failed to save project.", type: 'error' });
        }
    };

    const handleViewProposal = () => {
        navigate(`/proposal/proposals/${projectId}/${formData.projectName}`)
    };

    // Redirect to General tab when opening Add Projects
    useEffect(() => {
        if (location.pathname === "/project/add-projects") {
            const path = clientIdFromQuery
                ? `general?clientId=${clientIdFromQuery}`
                : `general`;
            navigate(path, { replace: true });
        }

        if (isEditMode && location.pathname === `/project/edit-projects/${projectId}`) {
            navigate(`general`, { replace: true,state: location.state });
        }
    }, [location, navigate, isEditMode, projectId, clientIdFromQuery]);

    const { ConfirmLeaveDialog } = useFormUnsavedChanges({
        formData,
        initialFormData,
        routesToBlock: majorRoutes
    });

    const handleTabChange = async (_event: React.SyntheticEvent, newValue: string) => {
        navigate(newValue);

        // const clickedTab = tabs.find(t => t.path === newValue);
        // const currentTab = tabs.find(t => t.path === location.pathname);

        // // If leaving "Forecast Tracker", unlock it
        // if (currentTab?.name === "Forecast Tracker") {
        //     try {
        //         await requestUnlock(FormType.ForecastTracker, Number(projectId));
        //     } catch (err) {
        //         console.error("Unlock failed:", err);
        //     }
        // }

        // // If entering "Forecast Tracker", request lock
        // if (clickedTab?.name === "Forecast Tracker") {
        //     try {
        //         const res = await requestLock(FormType.ForecastTracker, Number(projectId), userName!);
        //         if (res.success) {
        //             navigate(newValue);
        //         } else {
        //             setToast({ open: true, message: res.message, type: "warning" });
        //         }
        //     } catch (err) {
        //         console.error("Lock request failed", err);
        //     }
        // } else {
        //     // For all other tabs, just navigate
        //     navigate(newValue);
        // }
    };

    return (
        <AppLayout>
            <Box sx={{display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden', minHeight: 0}}>
            {/* Title & Buttons Container */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
                {/* Title with Back Button */}
                <Box sx={{ display: "flex", alignItems: "center", }}>
                    <IconButton sx={{ width: '40px', height: '40px', backgroundColor: 'transparent' }}
                        onClick={() => {
                            if(fromPage)
                            {
                                navigate(fromPage);
                            }
                            else if (clientIdFromQuery) {
                                // Navigate to client details page if clientId is available
                                navigate(`/client/add-client/${clientIdFromQuery}`);
                            }
                            
                             else {
                                // Default navigation
                                navigate("/project/projects");
                            }
                        }}
                        size="small">
                        <ArrowBackIosIcon sx={{ color: "#1e66ab", fontSize: "16px", stroke: "#1e66ab", strokeWidth: "0px" }} />
                    </IconButton>
                    <Typography variant="h6"  sx={headingStyles}>
                        {isEditMode ? `Edit Project` : 'Add Project'}
                    </Typography>
                </Box>

                {/* Buttons */}
                <Box sx={{ display: "flex", gap: 2, width: "35%" }}>
                    <CustomButton capsule
                        disabled={!isEditMode}
                        sx={{
                            textTransform: "none",
                            whiteSpace: "nowrap",
                            width: "100%"
                        }}
                        backgroundColor="#1e66ab"
                        hoverColor="rgba(150, 193, 33, 0.75)"
                        onClick={handleViewProposal}
                    >
                        View Proposals
                    </CustomButton>
                    <CustomButton
                        capsule
                        sx={{ textTransform: "none", whiteSpace: "nowrap", width: "100%" }}
                        onClick={handleSaveProject}>
                        {isEditMode ? 'Update Project' : 'Save Project'}
                    </CustomButton>
                </Box>
            </Box>
            
            {/* Tabs & Content */}
            <Box sx={{display: 'flex', flexDirection: 'column', flexGrow: 1, minHeight: 0}}>
                <TopBar tabs={tabs} width={isEditMode ? "100%" : "15%"} onChange={handleTabChange} />
                <Box sx={{
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                overflowY: "auto",
                overflowX: "hidden",
                // height: "calc(100vh - 190px)",
                pt: 2  
            }}>
                <Outlet context={[formData, setFormData, setInitialFormData, errors, setErrors, afpData, setAfpData]} />
                <Toaster open={toast.open} message={toast.message} type={toast.type as "success" | "error" | "warning"} onClose={() => setToast({ ...toast, open: false })} />
            </Box>
            </Box>
            </Box>
            
            <ConfirmLeaveDialog />
        </AppLayout>
    );
};

export default AddProject;